<template>
    <div class="components-forms">
        <div class="forms-header">
            <div class="header-list">
                <div v-for="item in headerlist"
                    :key="item.id" 
                    :class="{'active': activeTabs === item.id, 'header-item': true}"
                    @click="changeTabs(item)"
                >
                    {{ item.title }}
                </div>
            </div>
        </div>
        <div class="forms-body">
            <van-form v-if="activeTabs === 'company'" scroll-to-error @submit="companySubmitForm">
                <van-cell-group inset>
                    <van-field
                        v-model="companyForm.company"
                        name="company"
                        required
                        label="企业名称"
                        placeholder="请输入企业名称"
                        maxlength="20"
                        type="text"
                        show-word-limit
                        :rules="[{required: true, message: '请输入企业名称'}]"
                    />
                    <van-field name="logo" required label="企业LOGO" :rules="[{required: true, message: '请上传企业LOGO'}]">
                        <template #input>
                            <van-uploader
                                v-model="companyForm.logo"
                                :max-count="1"
                                accept="image/*"
                                :after-read="companyLogoUpload"
                            />
                        </template>
                    </van-field>
                    <van-field
                        v-model="companyForm.name"
                        name="name"
                        required
                        label="演讲人姓名"
                        placeholder="请输入您的姓名"
                        maxlength="20"
                        type="text"
                        show-word-limit
                        :rules="[{required: true, message: '请输入您的姓名'}]"
                    />
                    <van-field
                        v-model="companyForm.title"
                        name="title"
                        required
                        label="演讲人职务"
                        placeholder="请输入您的职务"
                        maxlength="20"
                        type="text"
                        show-word-limit
                        :rules="[{required: true, message: '请输入您的职务'}]"
                    />
                    <van-field name="speakerPhoto" required label="演讲人照片" :rules="[{required: true, message: '请上传演讲人照片'}]">
                        <template #input>
                            <van-uploader
                                v-model="companyForm.speakerPhoto"
                                :max-count="1"
                                accept="image/*"
                                :after-read="companySpeakUpload"
                            />
                        </template>
                    </van-field>
                    <van-field
                        v-model="companyForm.phone"
                        name="phone"
                        required
                        label="手机号"
                        placeholder="请输入手机号"
                        :rules="[{ validator:checkPhone, message:checkMessage }]"
                    />
                    <van-field
                        v-model="companyForm.email"
                        name="email"
                        required
                        label="邮箱"
                        placeholder="请输入邮箱"
                        :rules="[{ validator:checkEmail, message:checkMessage }]"
                    />
                    <van-field
                        v-model="companyForm.topicTitle"
                        name="topicTitle"
                        required
                        label="议题标题"
                        placeholder="请输入议题标题"
                        maxlength="20"
                        type="text"
                        show-word-limit
                        :rules="[{required: true, message: '请输入议题标题'}]"
                    />
                    <van-field
                        v-model="companyForm.topicAbstract"
                        name="topicAbstract"
                        label="议题简介"
                        placeholder="请简要描述您的议题内容"
                        rows="2"
                        autosize
                        maxlength="100"
                        type="textarea"
                        show-word-limit
                    />
                    <van-field name="industryField" required label="所属领域">
                        <template #input>
                            <el-radio-group v-model="industryField" @change="industryFieldChange">
                                <el-radio value="ai">AI技术与应用</el-radio>
                                <el-radio value="security">AI安全与创新</el-radio>
                            </el-radio-group>
                        </template>
                    </van-field>
                    <van-field
                        v-model="companyForm.topicArea"
                        is-link
                        readonly
                        name="topicArea"
                        required
                        label="议题领域"
                        placeholder="点击选择议题领域"
                        @click="showPicker = true"
                        :rules="[{required: true, message: '请选择议题领域'}]"
                    />
                    <van-popup v-model:show="showPicker" position="bottom">
                        <van-picker
                            :columns="AreaList"
                            @confirm="onConfirmSelect"
                            @cancel="showPicker = false"
                        />
                    </van-popup>
                    <van-field name="isChecked" label="" :rules="[{ validator:checkRules, message:checkMessage}]">
                        <template #input>
                            <van-checkbox v-model="companyForm.isChecked" icon-size="16px" shape="square">
                                <span><span style="color: #ee0a24;">*</span>阅读并同意
                                    <a style="color: #409eff;" href="https://cdn.isc.360.com/isc-cxo/ISC.AI%C2%A02025%C2%A0%E8%AE%AE%E9%A2%98%E5%BE%81%E9%9B%86%E6%8F%90%E4%BA%A4%E8%AF%B4%E6%98%8E.pdf"  target="_blank">《议题征集协议》</a>
                                    <a style="color: #409eff;" href="https://cdn.isc.360.com/isc-cxo/ISC.AI_2025_topic_rule.pdf"  target="_blank">《活动规则》</a>
                                </span>
                            </van-checkbox>
                        </template>
                    </van-field>
                </van-cell-group>
                <div style="margin: 20px 50px 0;">
                    <van-button round block type="primary" native-type="submit">
                    提交
                    </van-button>
                </div>
            </van-form>
            <van-form v-if="activeTabs === 'other'" scroll-to-error @submit="universitySubmitForm">
                <van-cell-group inset>
                    <van-field
                        v-model="universityForm.other"
                        name="other"
                        required
                        label="机构名称"
                        placeholder="请输入机构名称"
                        maxlength="20"
                        type="text"
                        show-word-limit
                        :rules="[{required: true, message: '请输入机构名称'}]"
                    />
                    <van-field
                        v-model="universityForm.name"
                        name="name"
                        required
                        label="演讲人姓名"
                        placeholder="请输入您的姓名"
                        maxlength="20"
                        type="text"
                        show-word-limit
                        :rules="[{required: true, message: '请输入您的姓名'}]"
                    />
                    <van-field
                        v-model="universityForm.title"
                        name="title"
                        required
                        label="演讲人职务"
                        placeholder="请输入您的职务"
                        maxlength="20"
                        type="text"
                        show-word-limit
                        :rules="[{required: true, message: '请输入您的职务'}]"
                    />
                    <van-field name="logo" required label="演讲人照片" :rules="[{required: true, message: '请上传演讲人照片'}]">
                        <template #input>
                            <van-uploader
                                v-model="universityForm.logo"
                                :max-count="1"
                                accept="image/*"
                                :after-read="universityLogoUpload"
                            />
                        </template>
                    </van-field>
                    <van-field
                        v-model="universityForm.phone"
                        name="phone"
                        required
                        label="手机号"
                        placeholder="请输入手机号"
                        :rules="[{ validator:checkPhone, message:checkMessage }]"
                    />
                    <van-field
                        v-model="universityForm.email"
                        name="email"
                        required
                        label="邮箱"
                        placeholder="请输入邮箱"
                        :rules="[{ validator:checkEmail, message:checkMessage }]"
                    />
                    <van-field
                        v-model="universityForm.topicTitle"
                        name="topicTitle"
                        required
                        label="议题标题"
                        placeholder="请输入议题标题"
                        maxlength="20"
                        type="text"
                        show-word-limit
                        :rules="[{required: true, message: '请输入议题标题'}]"
                    />
                    <van-field
                        v-model="universityForm.topicAbstract"
                        name="topicAbstract"
                        label="议题简介"
                        placeholder="请简要描述您的议题内容"
                        rows="2"
                        autosize
                        maxlength="100"
                        type="textarea"
                        show-word-limit
                    />
                    <van-field name="industryField" required label="所属领域">
                        <template #input>
                            <el-radio-group v-model="industryField" @change="industryFieldChange">
                                <el-radio value="ai">AI技术与应用</el-radio>
                                <el-radio value="security">AI安全与创新</el-radio>
                            </el-radio-group>
                        </template>
                    </van-field>
                    <van-field
                        v-model="universityForm.topicArea"
                        is-link
                        readonly
                        name="topicArea"
                        required
                        label="议题领域"
                        placeholder="点击选择议题领域"
                        @click="showPicker = true"
                        :rules="[{required: true, message: '请选择议题领域'}]"
                    />
                    <van-popup v-model:show="showPicker" position="bottom">
                        <van-picker
                            :columns="AreaList"
                            @confirm="onConfirmSelect"
                            @cancel="showPicker = false"
                        />
                    </van-popup>
                    <van-field name="isChecked" label="" :rules="[{ validator:checkRules, message:checkMessage}]">
                        <template #input>
                            <van-checkbox v-model="universityForm.isChecked" icon-size="16px" shape="square">
                                <span><span style="color: #ee0a24;">*</span>阅读并同意
                                    <a style="color: #409eff;" href="https://cdn.isc.360.com/isc-cxo/ISC.AI%C2%A02025%C2%A0%E8%AE%AE%E9%A2%98%E5%BE%81%E9%9B%86%E6%8F%90%E4%BA%A4%E8%AF%B4%E6%98%8E.pdf"  target="_blank">《议题征集协议》</a>
                                    <a style="color: #409eff;" href="https://cdn.isc.360.com/isc-cxo/ISC.AI_2025_topic_rule.pdf"  target="_blank">《活动规则》</a>
                                </span>
                            </van-checkbox>
                        </template>
                    </van-field>
                </van-cell-group>
                <div style="margin: 20px 50px 0;">
                    <van-button round block type="primary" native-type="submit">
                    提交
                    </van-button>
                </div>
            </van-form>
            <van-form v-if="activeTabs === 'personal'" scroll-to-error @submit="personalSubmitForm">
                <van-cell-group inset>
                    <van-field
                        v-model="personalForm.name"
                        name="name"
                        required
                        label="演讲人姓名"
                        placeholder="请输入您的姓名"
                        maxlength="20"
                        type="text"
                        show-word-limit
                        :rules="[{required: true, message: '请输入您的姓名'}]"
                    />
                    <van-field name="logo" required label="演讲人照片" :rules="[{required: true, message: '请上传演讲人照片'}]">
                        <template #input>
                            <van-uploader
                                v-model="personalForm.logo"
                                :max-count="1"
                                accept="image/*"
                                :after-read="personalLogoUpload"
                            />
                        </template>
                    </van-field>
                    <van-field
                        v-model="personalForm.company"
                        name="company"
                        label="公司名称"
                        placeholder="请输入公司名称"
                        maxlength="20"
                        type="text"
                        show-word-limit
                    />
                    <van-field
                        v-model="personalForm.title"
                        name="title"
                        label="职务"
                        placeholder="请输入您的职务"
                        maxlength="20"
                        type="text"
                        show-word-limit
                    />
                    <van-field
                        v-model="personalForm.phone"
                        name="phone"
                        required
                        label="手机号"
                        placeholder="请输入手机号"
                        :rules="[{ validator:checkPhone, message:checkMessage }]"
                    />
                    <van-field
                        v-model="personalForm.email"
                        name="email"
                        required
                        label="邮箱"
                        placeholder="请输入邮箱"
                        :rules="[{ validator:checkEmail, message:checkMessage }]"
                    />
                    <van-field
                        v-model="personalForm.topicTitle"
                        name="topicTitle"
                        required
                        label="议题标题"
                        placeholder="请输入议题标题"
                        maxlength="20"
                        type="text"
                        show-word-limit
                        :rules="[{required: true, message: '请输入议题标题'}]"
                    />
                    <van-field
                        v-model="personalForm.topicAbstract"
                        name="topicAbstract"
                        label="议题简介"
                        placeholder="请简要描述您的议题内容"
                        rows="2"
                        autosize
                        maxlength="100"
                        type="textarea"
                        show-word-limit
                    />
                    <van-field name="industryField" required label="所属领域">
                        <template #input>
                            <el-radio-group v-model="industryField" @change="industryFieldChange">
                                <el-radio value="ai">AI技术与应用</el-radio>
                                <el-radio value="security">AI安全与创新</el-radio>
                            </el-radio-group>
                        </template>
                    </van-field>
                    <van-field
                        v-model="personalForm.topicArea"
                        is-link
                        readonly
                        name="topicArea"
                        required
                        label="议题领域"
                        placeholder="点击选择议题领域"
                        @click="showPicker = true"
                        :rules="[{required: true, message: '请选择议题领域'}]"
                    />
                    <van-popup v-model:show="showPicker" position="bottom">
                        <van-picker
                            :columns="AreaList"
                            @confirm="onConfirmSelect"
                            @cancel="showPicker = false"
                        />
                    </van-popup>
                    <van-field name="isChecked" label="" :rules="[{ validator:checkRules, message:checkMessage}]">
                        <template #input>
                            <van-checkbox v-model="personalForm.isChecked" icon-size="16px" shape="square">
                                <span><span style="color: #ee0a24;">*</span>阅读并同意
                                    <a style="color: #409eff;" href="https://cdn.isc.360.com/isc-cxo/ISC.AI%C2%A02025%C2%A0%E8%AE%AE%E9%A2%98%E5%BE%81%E9%9B%86%E6%8F%90%E4%BA%A4%E8%AF%B4%E6%98%8E.pdf"  target="_blank">《议题征集协议》</a>
                                    <a style="color: #409eff;" href="https://cdn.isc.360.com/isc-cxo/ISC.AI_2025_topic_rule.pdf"  target="_blank">《活动规则》</a>
                                </span>
                            </van-checkbox>
                        </template>
                    </van-field>
                </van-cell-group>
                <div style="margin: 20px 50px 0;">
                    <van-button round block type="primary" native-type="submit">
                    提交
                    </van-button>
                </div>
            </van-form>
        </div>
        <dialogVue ref="dialogRef" :data="posterInfo"></dialogVue>
    </div>
</template>
  
<script setup>
import { ref, onMounted, reactive } from 'vue';
import dialogVue from './myDialog.vue';
import { submitForm,uploadImg } from '@/api/2025';
import { ElLoading } from 'element-plus';
import { showFailToast } from 'vant';
import piexif from 'piexifjs'

onMounted(() => {
    industryFieldChange('ai')
})

let activeTabs = ref('company');
let dialogRef = ref(null)

let headerlist = ref([
{
    title: '企业',
    id: 'company'
},
{
    title: '机构',
    id: 'other'
},
{
    title: '个人',
    id: 'personal'
}
]);

let industryField = ref('ai')
let posterInfo = ref({}) //海报列表

const changeTabs = (item) => {
    activeTabs.value = item.id;
    industryFieldChange('ai')
}

let AreaList = ref([])

const getAreaList = (type) => {
    if(type == 'ai'){
        AreaList.value = [
            { value: "大模型技术",text: "大模型技术" },
            { value: "智能体技术",text: "智能体技术" },
            { value: "具身智能技术",text: "具身智能技术" },
            { value: "企业级AI应用",text: "企业级AI应用" },
            { value: "垂直行业AI应用",text: "垂直行业AI应用" }
        ]
    }else if(type == 'security'){
        AreaList.value = [
            { value: "模型层安全",text: "模型层安全" },
            { value: "数据层安全",text: "数据层安全" },
            { value: "应用层安全",text: "应用层安全" },
            { value: "AI治理与合规",text: "AI治理与合规" },
            { value: "安全大模型",text: "安全大模型" },
            { value: "安全智能体",text: "安全智能体" },
            { value: "新型安全威胁与防御",text: "新型安全威胁与防御" },
            { value: "企业级应用",text: "企业级应用" },
            { value: "垂直行业应用",text: "垂直行业应用" }
        ]
    }
}
const industryFieldChange = (val) => {
    industryField.value = val
    companyForm.topicArea = ''
    universityForm.topicArea = ''
    personalForm.topicArea = ''
    getAreaList(val)
}

const onConfirmSelect = (val) => {
    if (activeTabs.value == 'company') {
        companyForm.topicArea = val.selectedValues[0]
    }else if (activeTabs.value == 'other') {
        universityForm.topicArea = val.selectedValues[0]
    }else if (activeTabs.value == 'personal') {
        personalForm.topicArea = val.selectedValues[0]
    }
    showPicker.value = false;
}

const companyForm = reactive({
    logo: [],
    company: '',
    name: '',
    title: '',
    speakerPhoto: [],
    phone: '',
    email: '',
    topicTitle: '',
    topicAbstract: '',
    topicArea: '',
    isChecked: false,
    Orientation: 1
})
const universityForm = reactive({
    other: '',
    logo: [],
    name: '',
    title: '',
    phone: '',
    email: '',
    topicTitle: '',
    topicAbstract: '',
    topicArea: '',
    isChecked: false,
    Orientation: 1
})
const personalForm = reactive({
    logo: [],
    name: '',
    company: '',
    title: '',
    phone: '',
    email: '',
    topicTitle: '',
    topicAbstract: '',
    topicArea: '',
    isChecked: false,
    Orientation: 1
})

const showPicker = ref(false); //选择器

const checkPhone = (value) => { //手机号校验
    if (!value) {
        return '请填写手机号'
    }
    if (!(/^1[3456789]\d{9}$/.test(value))) {
        return '手机号格式有误，请检查'
    }
}
const checkEmail = (value) => { //校验邮箱
    if (!value) {
        return '请填写邮箱';
    }
    if (!(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value))) {
        return '邮箱格式有误，请检查';
    }
}
const checkRules = (value) => { //校验协议
    if (value==false) {
        return '请阅读并同意协议和规则';
    }
}
const checkMessage = (val) => `${val}`; //校验信息

const companyLogoUpload = (uploader) => {
  const file = uploader.file

  // 只处理 JPEG
  if (!file.type.includes('jpeg') && !file.type.includes('jpg')) {
    console.warn('不是 JPEG 图片，跳过 EXIF 分析')
    uploadImg(file).then(res => {
        if (res.data.msg == "SUCCESS") {
            file.url = res.data.data.imageurl
            companyForm.logo =[file]
        } else {
            showFailToast(res.data.msg)
            companyForm.logo = []
        }
    })
    return false
  }

  const reader = new FileReader()
  reader.onload = function (e) {
    const dataUrl = e.target.result

    try {
      const exifObj = piexif.load(dataUrl)
      const orientation = exifObj["0th"][piexif.ImageIFD.Orientation]
    //   console.log('EXIF Orientation:', orientation)
        companyForm.Orientation = orientation
      // 可在此处添加基于 orientation 的图像旋转处理逻辑

      // 然后调用上传逻辑
      return uploadImg(file).then(res => {
        if (res.data.msg == "SUCCESS") {
            file.url = res.data.data.imageurl
            companyForm.logo =[file]
        } else {
            showFailToast(res.data.msg)
            companyForm.logo = []
        }
    })

    } catch (error) {
      console.error('读取 EXIF 出错', error)
      // 继续上传
      return uploadImg(file).then(res => {
        if (res.data.msg == "SUCCESS") {
            file.url = res.data.data.imageurl
            companyForm.logo =[file]
        } else {
            showFailToast(res.data.msg)
            companyForm.logo = []
        }
    })
    }
  }

  reader.readAsDataURL(file)

  return false
}
const universityLogoUpload = (uploader) => {
  const file = uploader.file

  // 只处理 JPEG
  if (!file.type.includes('jpeg') && !file.type.includes('jpg')) {
    console.warn('不是 JPEG 图片，跳过 EXIF 分析')
    uploadImg(file).then(res => {
            if (res.data.msg == "SUCCESS") {
                file.url = res.data.data.imageurl
                universityForm.logo =[file]
            } else {
                showFailToast(res.data.msg)
                universityForm.logo = []
            }
        })
    return false
  }

  const reader = new FileReader()
  reader.onload = function (e) {
    const dataUrl = e.target.result
    try {
      const exifObj = piexif.load(dataUrl)
      const orientation = exifObj["0th"][piexif.ImageIFD.Orientation]
    //   console.log('EXIF Orientation:', orientation)
    universityForm.Orientation = orientation
      // 可在此处添加基于 orientation 的图像旋转处理逻辑

      // 然后调用上传逻辑
        return uploadImg(file).then(res => {
            if (res.data.msg == "SUCCESS") {
                file.url = res.data.data.imageurl
                universityForm.logo =[file]
            } else {
                showFailToast(res.data.msg)
                universityForm.logo = []
            }
        })

    } catch (error) {
      console.error('读取 EXIF 出错', error)
      // 继续上传
        return uploadImg(file).then(res => {
            if (res.data.msg == "SUCCESS") {
                file.url = res.data.data.imageurl
                universityForm.logo =[file]
            } else {
                showFailToast(res.data.msg)
                universityForm.logo = []
            }
        })
    }
  }

  reader.readAsDataURL(file)

  return false
}
const personalLogoUpload = (uploader) => {
  const file = uploader.file

  // 只处理 JPEG
  if (!file.type.includes('jpeg') && !file.type.includes('jpg')) {
    console.warn('不是 JPEG 图片，跳过 EXIF 分析')
    uploadImg(file).then(res => {
        if (res.data.msg === "SUCCESS") {
          file.url = res.data.data.imageurl
          personalForm.logo = [file]
        } else {
          showFailToast(res.data.msg)
          personalForm.logo = []
        }
      })
    return false
  }

  const reader = new FileReader()
  reader.onload = function (e) {
    const dataUrl = e.target.result

    try {
      const exifObj = piexif.load(dataUrl)
      const orientation = exifObj["0th"][piexif.ImageIFD.Orientation]
      console.log('EXIF Orientation:', orientation)
      personalForm.Orientation = orientation
      // 可在此处添加基于 orientation 的图像旋转处理逻辑

      // 然后调用上传逻辑
      return uploadImg(file).then(res => {
        if (res.data.msg === "SUCCESS") {
          file.url = res.data.data.imageurl
          personalForm.logo = [file]
        } else {
          showFailToast(res.data.msg)
          personalForm.logo = []
        }
      })

    } catch (error) {
      console.error('读取 EXIF 出错', error)
      // 继续上传
      return uploadImg(file).then(res => {
        if (res.data.msg === "SUCCESS") {
          file.url = res.data.data.imageurl
          personalForm.logo = [file]
        } else {
          showFailToast(res.data.msg)
          personalForm.logo = []
        }
      })
    }
  }

  reader.readAsDataURL(file)

  return false
}
const companySpeakUpload = (uploader) => {
    const file = uploader.file
    return uploadImg(file).then(res => {
        if (res.data.msg == "SUCCESS") {
            file.url = res.data.data.imageurl
            companyForm.speakerPhoto =[file]
        } else {
            showFailToast(res.data.msg)
            companyForm.speakerPhoto = []
        }
    })
}

const loadingInstance = ref(null)
const openLoading = () => {
    loadingInstance.value = ElLoading.service({
        lock: true,
        text: '正在生成您的专属海报，请稍候...',
        svg: `
            <path class="path" d="
            M 30 15
            L 28 17
            M 25.61 25.61
            A 15 15, 0, 0, 1, 15 30
            A 15 15, 0, 1, 1, 27.99 7.5
            L 15 15
            " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
        `,
        svgViewBox: "-10, -10, 50, 50",
        background: 'rgba(0, 0, 0, 0.8)',
        customClass: 'my-loading',
    })
}
const closeLoading = () => {
    loadingInstance.value.close()
}

const companySubmitForm = (values) => {
    let newData = JSON.parse(JSON.stringify(companyForm))
    newData.logo = newData.logo[0].url
    newData.speakerPhoto = newData.speakerPhoto[0].url
    newData.industryField = industryField.value
    newData.submissionMode = 'speak'
    newData.identityType = 'company'
    newData.form_id = 1
    openLoading()
    return submitForm(newData).then(res => {
        if (res.data.msg == "SUCCESS") {
            posterInfo.value = {
                title: newData.topicTitle,
                avatar: newData.speakerPhoto,
                name: newData.name,
            }
            setTimeout(() => {
                dialogRef.value.openModel()
                closeLoading()
            },1000)
        }else{
            closeLoading()
            showFailToast(res.data.msg)
        }
    })
}
const universitySubmitForm = (values) => {
    let newData = JSON.parse(JSON.stringify(universityForm))
    newData.logo = newData.logo[0].url
    newData.industryField = industryField.value
    newData.submissionMode = 'speak'
    newData.identityType = 'other'
    newData.form_id = 1
    openLoading()
    return submitForm(newData).then(res => {
        if (res.data.msg == "SUCCESS") {
            posterInfo.value = {
                title: newData.topicTitle,
                avatar: newData.logo,
                name: newData.name,
            }
            setTimeout(() => {
                dialogRef.value.openModel()
                closeLoading()
            },1000)
        }else{
            closeLoading()
            showFailToast(res.data.msg)
        }
    })
}
const personalSubmitForm = (values) => {
    let newData = JSON.parse(JSON.stringify(personalForm))
    newData.logo = newData.logo[0].url
    newData.industryField = industryField.value
    newData.submissionMode = 'speak'
    newData.identityType = 'personal'
    newData.form_id = 1
    openLoading()
    return submitForm(newData).then(res => {
        if (res.data.msg == "SUCCESS") {
            posterInfo.value = {
                title: newData.topicTitle,
                avatar: newData.logo,
                name: newData.name,
            }
            setTimeout(() => {
                dialogRef.value.openModel()
                closeLoading()
            },1000)
        }else{
            closeLoading()
            showFailToast(res.data.msg)
        }
    })
};


</script>

<style lang="scss" scoped>
.components-forms {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  margin-bottom: 40px;
  .forms-header{
    width: 100%;
    display: flex;
    justify-content: center;
    .header-list{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
      .header-item{
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32%;
        height: 40px;
        box-sizing: border-box;
        border-left: 1px solid rgb(170, 189, 225);
        border-right: 1px solid rgb(170, 189, 225);
        border-top: 1px solid rgb(170, 189, 225);
        border-radius: 12px 12px 0px 0px;
        background: rgb(227, 236, 255);
        color: rgb(110, 134, 179);
        font-family: Source Han Sans;
        font-size: 16px;
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 4px;
        &:hover{
            color: rgb(25, 104, 255);
        }
        &.active{
            height: 42px;
            margin-bottom: -2px;
            border-left: 1px solid rgb(213, 209, 209);
            border-right: 1px solid rgb(213, 209, 209);
            border-top: 1px solid rgb(213, 209, 209);
            border-radius: 12px 12px 0px 0px;
            background: #fafafa;
            color: rgb(25, 104, 255);
            font-family: Source Han Sans;
            font-size: 16px;
            font-weight: 700;
            line-height: 16px;
            letter-spacing: 4px;
            z-index: 1;
        }
      }
    }
  }
  .forms-body{
        width: 100%;
        padding: 20px 0;
        background: #fafafa;
        border-radius: 0 0 12px 12px;
        border: 1px solid rgb(230, 226, 226);
        box-shadow: 0 8px 12px #ebedf0;
        :deep(.van-field__label){
            margin-right: 0px;
        }
        :deep(.el-radio){
            margin-right: 12px;
        }
    }
}
</style>